import { render, staticRenderFns } from "./ClientPaymentTable.vue?vue&type=template&id=5afa31c6&"
import script from "./ClientPaymentTable.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports